import { render, staticRenderFns } from "./ShoppingBagDeleteteIcon.vue?vue&type=template&id=0f52c3be&"
import script from "./ShoppingBagDeleteteIcon.vue?vue&type=script&lang=js&"
export * from "./ShoppingBagDeleteteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports